import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { map, of } from 'rxjs';
import { ISessionStatistics } from '../interfaces/ISessionStatistics';
import { StatisticsStore } from '../stores/StatisticsStore';
import { StatisticsService } from '../services/StatisticsService';
import { WebCashPermissionKeys } from '../../../../core/enums/WebCashPermissionKeys';
import { PermissionService } from '../../../auth/core/services/PermissionService';
import { TerminalsStore } from '../../../terminals/core/stores/TerminalsStore';

export const sessionStatisticsResolver: ResolveFn<ISessionStatistics> = () => {
  if (
    !inject(PermissionService).hasPermission(WebCashPermissionKeys.WebCxCashSessionStatistics) ||
    !inject(TerminalsStore).selectedTerminal().currentSession.safeId
  ) {
    return of(null);
  }

  const sessionStatistics = inject(StatisticsStore).sessionStatistics();

  if (sessionStatistics) {
    return sessionStatistics;
  } else {
    return inject(StatisticsService).getSessionStatistics().pipe(
      map(res => res?.data ?? null)
    );
  }
};
